"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var colors_1 = require("@mui/material/colors");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var react_1 = require("react");
var stripe_js_1 = require("@stripe/stripe-js");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
// components
var Stripe_1 = __importDefault(require("./Stripe"));
// utils
var determineEnv_1 = __importDefault(require("../utils/determineEnv"));
// data
var config_json_1 = __importDefault(require("../config.json"));
var stripePromise = (0, stripe_js_1.loadStripe)(config_json_1.default.stripePublishableKey[(0, determineEnv_1.default)()]);
var BuyForm = function (_a) {
    var setBuyFormEnabled = _a.setBuyFormEnabled, price = _a.price, courseId = _a.courseId, courseName = _a.courseName;
    // form logic
    var _b = __read((0, react_1.useState)(1), 2), step = _b[0], setStep = _b[1];
    var _c = __read((0, react_1.useState)(''), 2), clientSecret = _c[0], setClientSecret = _c[1];
    // form values
    var _d = __read((0, react_1.useState)(undefined), 2), nombre = _d[0], setNombre = _d[1];
    var _e = __read((0, react_1.useState)(undefined), 2), email = _e[0], setEmail = _e[1];
    // validation vars
    var _f = __read((0, react_1.useState)(undefined), 2), nombreError = _f[0], setNombreError = _f[1];
    var _g = __read((0, react_1.useState)(undefined), 2), emailError = _g[0], setEmailError = _g[1];
    var _h = __read((0, react_1.useState)(false), 2), formValid = _h[0], setFormValid = _h[1];
    (0, react_1.useEffect)(function () {
        setNombreError(undefined);
        if (nombre === '') {
            setNombreError('El nombre es obligatorio');
        }
    }, [nombre]);
    (0, react_1.useEffect)(function () {
        setEmailError(undefined);
        if (email === '') {
            setEmailError('El email es obligatorio');
        }
        if (email && !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setEmailError('El email no es válido');
        }
    }, [email]);
    (0, react_1.useEffect)(function () {
        setFormValid(false);
        if (nombre && email && !nombreError && !emailError) {
            setFormValid(true);
        }
    });
    var handleKeyDown = function (event) {
        if (event.key === 'Enter') {
            nextFunction();
        }
    };
    var nextFunction = function () {
        if (!formValid)
            return;
        getClientSecret();
        setStep(2);
    };
    var generateDescription = function (name) {
        return "".concat(name, " - ").concat(courseName);
    };
    var getClientSecret = function () {
        if (!price)
            return;
        var priceInt = parseInt(price);
        if (isNaN(priceInt))
            return;
        var createPaymentIntentionBody = {
            amount: priceInt,
            description: generateDescription(nombre),
            name: nombre || '',
            email: email || '',
            productId: courseId || '',
        };
        fetch("".concat(config_json_1.default.opositandoApi[(0, determineEnv_1.default)()], "/createPaymentIntention"), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(createPaymentIntentionBody),
        })
            .then(function (res) { return res.json(); })
            .then(function (data) { return setClientSecret(data.response); });
    };
    var NextButton = (0, material_1.styled)(material_1.Button)(function (_a) {
        var theme = _a.theme;
        return ({
            color: theme.palette.getContrastText(colors_1.green[500]),
            backgroundColor: colors_1.green[500],
            '&:hover': {
                backgroundColor: colors_1.green[700],
            },
        });
    });
    var BackButton = (0, material_1.styled)(material_1.Button)(function (_a) {
        var theme = _a.theme;
        return ({
            color: '#000',
            border: '1px solid #000',
            backgroundColor: '#fff',
        });
    });
    var appearance = {
        theme: 'stripe',
    };
    var options = {
        clientSecret: clientSecret,
        appearance: appearance,
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "opo-checkout-buyform" }, { children: [step === 1 && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "opo-checkout-buyform-title" }, { children: "1. Datos personales:" })), (0, jsx_runtime_1.jsx)(TextField_1.default, { id: "buy-form-name", label: "Nombre", variant: "outlined", margin: "none", value: nombre, error: !!nombreError, helperText: nombreError, onChange: function (e) { return setNombre(e.target.value); }, onKeyDown: handleKeyDown, fullWidth: true, required: true }), (0, jsx_runtime_1.jsx)(TextField_1.default, { id: "buy-form-email", label: "E-mail", variant: "outlined", margin: "none", value: email, error: !!emailError, helperText: emailError, onChange: function (e) { return setEmail(e.target.value.replace(/\s/g, '')); }, onKeyDown: handleKeyDown, fullWidth: true, required: true }), (0, jsx_runtime_1.jsx)(NextButton, __assign({ disabled: !formValid, onClick: function () {
                            nextFunction();
                        } }, { children: "Siguiente" })), (0, jsx_runtime_1.jsx)("a", __assign({ onClick: function () { return setBuyFormEnabled(false); } }, { children: "Cancelar" }))] })), step === 2 && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "opo-checkout-buyform-title" }, { children: "2. M\u00E9todo de pago:" })), clientSecret && ((0, jsx_runtime_1.jsx)(react_stripe_js_1.Elements, __assign({ options: options, stripe: stripePromise }, { children: (0, jsx_runtime_1.jsx)(Stripe_1.default, { price: price, clientSecret: clientSecret }) }))), !clientSecret && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "opo-checkout-buyform-loading" }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { color: "success", sx: { color: "#264653" } }) }))), (0, jsx_runtime_1.jsx)(BackButton, __assign({ onClick: function () { return setStep(1); } }, { children: "Atr\u00E1s" }))] }))] })));
};
exports.default = BuyForm;
//# sourceMappingURL=BuyForm.js.map